import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { initPrefs } from "@/lib/prefs";

initPrefs();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary label="sanctuary">
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker for offline shell + push (idempotent; the same SW
// handles both). Deferred to load so it never blocks first paint.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { scope: "/" }).catch(() => {});
  });
}
